import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import ATSListDisplay from './ATSListDisplay';

class ATSWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      props : this.props,
      navigate : this.props.navigate,
      symbol: this.props.symbol
    };
    console.log('ATSWrap ', this.state.symbol);
  }

  componentDidMount() {
    console.log(' cache', caches);
    // caches.keys().then((names) => {
    //   names.forEach((name) => {
    //     console.log('clear cache', name);
    //     //caches.delete(name);
    //   });
    // });
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Alternative Trading System (ATS) / Dark Pool</title>
          <meta charSet="utf-8" />
          <link rel="canonical" href="https://www.vizfm.com/ats" />
          <meta name="description" content="Alternative Trading System (ATS) / Dark Pool for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col>Alternative Trading System (ATS) Screener</Col>
          </Row>
          <Row>
            <Col><ATSListDisplay symbol={this.state.symbol}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ATSWrap;
